import React from 'react'
import { Grid } from '@material-ui/core'
import { Link } from 'react-router-dom'
import { Button, Card } from '../../components'
import { utils } from '../../utils'
import TextInput from './TextInput'

export default function LoginCustomer({ hasPortabilidade, filials, isMobile, login }) {
    const [matricula, setMatricula] = React.useState('')
    const [password, setPassword] = React.useState('')
    const [loading, setLoading] = React.useState(false)

    async function handleLogin(evt) {
        evt.preventDefault()
        setLoading(true)
        await login({
            matricula,
            password,
        })
        setLoading(false)
        setLoading(false)
    }

    const canLoginMethod = React.useCallback(
        items => {
            if (!items) {
                return false
            }

            if (matricula.trim() === '' || password.trim().length !== 6) {
                return false
            }

            const pswNumbers = password.replace(/[^0-9]/g, '')
            if (pswNumbers.length !== 6) {
                return false
            }

            const letter = matricula.replace(/[0-9]/g, '')
            if (letter.length !== 1) {
                return false
            }

            const codes = items.map(e => e.code.toUpperCase())
            if (!codes.includes(letter.toUpperCase())) {
                return false
            }

            const psd = `${matricula.replace(/[^0-9]/g, '')}${letter}`
            if (psd !== matricula) {
                return false
            }
            return true
        },
        [matricula, password]
    )

    const canLogin = canLoginMethod(filials)

    return (
        <div>
            <Card>
                {hasPortabilidade ? <div className="ansTitle">ANS concede portabilidade especial aos beneficiários da Camim.</div> : <div className="ansTitle">Se você é um cliente Camim</div>}

                <form style={{ display: 'flex', flexDirection: 'column', gap: '1em' }} autoComplete="off" onSubmit={handleLogin}>
                    <TextInput label="Matrícula" placeholder="Informe a matrícula" type="text" fullWidth value={matricula} onChangeText={setMatricula} onFormatValue={utils.allowMatricula(filials)} />
                    <TextInput
                        style={{ marginTop: 4 }}
                        label="Senha"
                        placeholder="Informe a senha com 6 dígitos"
                        type="password"
                        fullWidth
                        value={password}
                        onChangeText={setPassword}
                        onFormatValue={utils.limitPassword}
                    />
                    <Grid container>
                        <Grid item xs={isMobile ? 7 : 6}>
                            <Link to="/recuperar-senha">
                                <Button type="button" variant="text" disabled={loading} className="sectionColor btn-forgot">
                                    Esqueci a senha
                                </Button>
                            </Link>
                        </Grid>
                        <Grid item xs={isMobile ? 5 : 6} style={{ textAlign: 'right' }}>
                            <Button type="submit" tabIndex="-1" isRequesting={loading} disabled={loading || !canLogin} color={canLogin ? 'primary' : 'secondary'}>
                                Entrar
                            </Button>
                        </Grid>
                    </Grid>
                    <br />
                    <div className="destaque left">O último caracter da matrícula deve obrigatoriamente conter a letra correspondente, como consta na Carteirinha e no Contrato.</div>
                </form>
            </Card>
        </div>
    )
}
